import { createAction, createReducer } from 'redux-act';

export type IState = {
  timeout: number;
  errorMessage: string;
};

const initialState: IState = {
  timeout: 0,
  errorMessage: null,
};

export const setSmsCodeStatusTimeout = createAction<number>('smsCodeStatus/setTimeout');
export const setSmsCodeStatusError = createAction<string>('smsCodeStatus/setError');

export default createReducer<IState>({}, initialState)
  .on(setSmsCodeStatusTimeout, (state, payload) => ({
    ...state,
    timeout: payload,
  }))
  .on(setSmsCodeStatusError, (state, payload) => ({
    ...state,
    errorMessage: payload,
  }));
